import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

function readCookie(name: string): string | null {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
}

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const isApiCall = req.url.startsWith(environment.apiBaseUrl);
  if (!isApiCall) return next(req);

  let request = req.clone({ withCredentials: true });

  if (!SAFE_METHODS.has(request.method)) {
    const token = readCookie('XSRF-TOKEN');
    if (token) {
      request = request.clone({ setHeaders: { 'X-XSRF-TOKEN': token } });
    }
  }

  return next(request);
};
